import { Component, ElementRef, Input, OnInit, ViewChild } from '@angular/core';
import { ModalService } from '@shared/modal-service/modal-service.service';
import { ModalRef } from '@shared/modal-service/models/modal-ref.model';
import { QuillViewComponent } from 'ngx-quill';
import { FreeTextPopupComponent } from '../free-text-popup/free-text-popup.component';

@Component({
  selector: 'od-free-text-output',
  templateUrl: './free-text-output.component.html',
  styleUrls: ['./free-text-output.component.scss'],
  standalone: false,
})
export class FreeTextOutputComponent implements OnInit {
  public canRenderQuill = false;
  public quillContentBig = false;
  public quillContentShown = false;
  public modalRef = {} as ModalRef;
  @Input() title: string = '';
  @Input() content: string = '';

  @ViewChild('textWrapper') private textWrapper: ElementRef;
  @ViewChild(QuillViewComponent) private quillView: QuillViewComponent;

  constructor(private modalService: ModalService) {}

  ngOnInit(): void {
    this.canRenderQuill = Boolean(this.content);
  }

  public calculateHeight() {
    setTimeout(() => {
      const textWrapperHeight = this.textWrapper.nativeElement.offsetHeight;
      const quill = this.quillView.editorElem;
      const editor = quill.querySelector<HTMLElement>('.ql-editor');
      const textContent = editor.offsetHeight;
      this.quillContentBig = textContent > textWrapperHeight;
    }, 0);
  }

  public openReferenceModal(event: PointerEvent): void {
    event.stopPropagation();
    const freeTextData = {
      title: this.title,
      description: this.content,
      confirm: {
        accept: 'Close',
      },
    };

    this.modalRef = this.modalService.open(
      FreeTextPopupComponent,
      freeTextData
    );
  }
}
